import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from '../layouts/RootLayout';
import { NavigableLayout } from '../layouts/NavigableLayout';

// Lazy-loaded page components
import { ConfigListPage } from '../pages/configs/ConfigListPage';
import { ConfigDetailPage } from '../pages/configs/ConfigDetailPage';
import { ConfigCreatePage } from '../pages/configs/ConfigCreatePage';
import { ConfigEditPage } from '../pages/configs/ConfigEditPage';
import { PendingDeletionsPage } from '../pages/configs/PendingDeletionsPage';
import { CampaignListPage } from '../pages/campaigns/CampaignListPage';
import { CampaignDetailPage } from '../pages/campaigns/CampaignDetailPage';
import { JourneyView } from '@features/journey/components/JourneyView';
import { WriteGuard, CampaignGuard } from '@features/auth';

export function createRouter() {
  return createBrowserRouter([
    {
      element: <RootLayout />,
      children: [
        {
          element: <NavigableLayout />,
          children: [
            { path: '/', element: <ConfigListPage /> },
            { path: '/journey', element: <JourneyView /> },
            { path: '/configs/:configId', element: <ConfigDetailPage /> },
            // Create and edit are not available to view-only users (campaign
            // uploaders). The API enforces this too.
            {
              path: '/configs/new',
              element: (
                <WriteGuard>
                  <ConfigCreatePage />
                </WriteGuard>
              ),
            },
            {
              path: '/configs/:configId/edit',
              element: (
                <WriteGuard>
                  <ConfigEditPage />
                </WriteGuard>
              ),
            },
            { path: '/pending-deletions', element: <PendingDeletionsPage /> },
            // Campaigns is for administrators and campaign uploaders. The API
            // must enforce this too — a hidden route is not authorisation.
            {
              path: '/campaigns',
              element: (
                <CampaignGuard>
                  <CampaignListPage />
                </CampaignGuard>
              ),
            },
            {
              path: '/campaigns/:campaignId',
              element: (
                <CampaignGuard>
                  <CampaignDetailPage />
                </CampaignGuard>
              ),
            },
          ],
        },
      ],
    },
  ]);
}
